export default __webpack_public_path__ + "static/media/view.7fea07c0.svg";